var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{class:['main-page', {'main-page-skeleton': _vm.isLoading}]},[_vm._l((_vm.list),function(item,itemIndex){return [_c(`s-${item.name}`,{key:`s-${itemIndex}`,tag:"component",attrs:{"content":{...item, tabActive: _vm.tabActive}},on:{"setTabActive":_vm.setTabActive}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }